export default __webpack_public_path__ + "media/images/icons_fc/briefcase-581d8b0f79fd11bd0f848a656bfa1af3.png";